import createFetchClient from "openapi-fetch";
import createQueryClient from "openapi-react-query";

import type { ApiPaths } from "./ApiPaths";
import { authMiddleware } from "./middleware/auth";
import { csrfMiddleware } from "./middleware/csrf";
import { errorsMiddleware } from "./middleware/errors";

// Клиент без React: для `queryClient.fetchQuery`, обработчиков событий и тестов.
// Адреса в схеме уже начинаются с `/api`, база — текущий origin: один образ работает на любом домене.
// `fetch` берётся при каждом запросе, а не при создании клиента, — иначе MSW в тестах его не перехватит.
export const apiClient = createFetchClient<ApiPaths>({
  baseUrl: window.location.origin,
  fetch: (request) => globalThis.fetch(request),
});

// Порядок важен: `onResponse` вызывается в обратном порядке, поэтому сначала `auth`
// замечает 401, а затем `errors` превращает ответ в `ApiError` и бросает его.
apiClient.use(csrfMiddleware, errorsMiddleware, authMiddleware);

// Хуки TanStack Query поверх клиента: `$api.useQuery`, `$api.useMutation`, `$api.queryOptions`.
// Ключ запроса — `[method, path, init]`, его же используют `invalidateQueries` и `setQueryData`.
export const $api = createQueryClient(apiClient);
